__turbopack_context__.v({
  "icon": "media-thumb-module__KJe7gG__icon",
  "image": "media-thumb-module__KJe7gG__image",
  "imageArrived": "media-thumb-module__KJe7gG__imageArrived",
  "lg": "media-thumb-module__KJe7gG__lg",
  "md": "media-thumb-module__KJe7gG__md",
  "placeholder": "media-thumb-module__KJe7gG__placeholder",
  "sm": "media-thumb-module__KJe7gG__sm",
  "spinner": "media-thumb-module__KJe7gG__spinner",
  "thumb": "media-thumb-module__KJe7gG__thumb",
  "thumb-fade-in": "media-thumb-module__KJe7gG__thumb-fade-in",
  "thumb-spin": "media-thumb-module__KJe7gG__thumb-spin",
});
